import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=192f9a4c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=192f9a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192f9a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192f9a4c')) {
      api.createRecord('192f9a4c', component.options)
    } else {
      api.reload('192f9a4c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=192f9a4c&scoped=true&", function () {
      api.rerender('192f9a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8yK2fSSWlyC8y/JS/comp/DocBox.vue"
export default component.exports